"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _colors = require("./colors");

var _chartDataTypes = require("../../constants/chartDataTypes");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var legendItems = [{
  dataType: _chartDataTypes.PRODUCTION,
  color: _colors.START_GRADIENT,
  isDashed: false,
  name: 'Solar'
}, {
  dataType: _chartDataTypes.BATTERY,
  color: _colors.BATTERY_CHARGE,
  isDashed: false,
  name: 'Battery'
}, {
  dataType: _chartDataTypes.CONSUMPTION,
  color: _colors.CUSTOMER_CONSUMPTION,
  isDashed: false,
  name: 'Consumption'
}, {
  dataType: _chartDataTypes.EXPECTED,
  color: _colors.START_GRADIENT,
  isDashed: true,
  name: 'Estimated Production'
}];

var LegendLine = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 22px;\n  border-bottom: 5px ", " ", ";\n  height: 0px;\n  display: inline-block;\n  margin-right: 6px;\n"])), function (_ref) {
  var isDashed = _ref.isDashed;
  return isDashed ? 'dashed' : 'solid';
}, function (_ref2) {
  var color = _ref2.color;
  return color;
});

var Wrap = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 20px;\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n"])));

var LegendItem = _styled["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: 8px 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));

var CustomerLegend = function CustomerLegend(_ref3) {
  var enabledDataTypes = _ref3.enabledDataTypes;
  return /*#__PURE__*/_react["default"].createElement(Wrap, null, legendItems.map(function (item) {
    if (enabledDataTypes.indexOf(item.dataType) > -1) {
      return /*#__PURE__*/_react["default"].createElement(LegendItem, {
        key: "".concat(item.dataType, "-legend-item")
      }, /*#__PURE__*/_react["default"].createElement(LegendLine, item), /*#__PURE__*/_react["default"].createElement("span", null, item.name));
    }
  }));
};

CustomerLegend.propTypes = {
  enabledDataTypes: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired
};
var _default = CustomerLegend;
exports["default"] = _default;